import withAxios from "../lib/withAxios";

class PtoTrackerService {
  getUserImage(payload) {
    return withAxios.postWithToken("/User/GetPhotoAsByteArray", payload);
  }
  //Submit the data for wfh request
  submitForApproval(payload) {
    return withAxios.postWithToken("/WFH/ProcessWFHFlexibilities", payload);
  }

  searchUser(payload) {
    return withAxios.postWithToken("/User/GetEmpName", payload);
  }

  statusSeasonsOptions(payload) {
    return withAxios.postWithToken("/Reports/ReportDropDownData", payload);
  }

  getUserDetails(payload) {
    return withAxios.postWithToken("/User/GetUserDetails", payload);
  }

  getDashboardDetails(payload) {
    return withAxios.postWithToken("/Common/DashboardData", payload);
  }

  isValidApprover(payload) {
    return withAxios.postWithToken("/Flexibility/IsValidApprover", payload);
  }

  getFlexibilitySummaryList(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetFlexibilitySummaryList",
      payload
    );
  }

  getFlexibilityTypes(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/GetFlexibilityTypesFromBusinessRules",
      payload
    );
  }

  getWFHSummaryList(payload) {
    return withAxios.postWithToken("/WFH/GetWFHSummaryList", payload);
  }

  getFlexibilityDetailsById(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetFlexibilityDetailsById",
      payload
    );
  }

  cancelPtoRequest(payload) {
    return withAxios.postWithToken(
      "/Flexibility/CancelFlexibilityRequest",
      payload
    );
  }

  calculateHours(payload) {
    return withAxios.postWithToken("/Flexibility/CalculatePTOHours", payload);
  }

  submitRequestOrApprove(payload) {
    return withAxios.postWithToken(
      "/Flexibility/ManageFlexibilityTracker",
      payload
    );
  }

  approveFlexibilityRequest(payload) {
    return withAxios.postWithToken(
      "/Flexibility/ApproveFlexibilityRequest",
      payload
    );
  }

  processFlexibilities(payload) {
    return withAxios.postWithToken(
      "/Flexibility/ProcessFlexibilities",
      payload
    );
  }

  getUserByEmail(payload) {
    return withAxios.postWithToken("/User/GetUserByEmail", payload);
  }
  getStartDateList(payload) {
    return withAxios.postWithToken("/WFH/GetWeekStartDateList", payload);
  }

  getNumberOfWeeks(payload) {
    return withAxios.postWithToken("/WFH/GetNoOfWeeks", payload);
  }

  getWorkFromHomeFlexibilities(payload) {
    return withAxios.postWithToken("/WFH/GetWFHDetailsById", payload);
  }
  manageWFHFlexibilityTracker(payload) {
    return withAxios.postWithToken("/WFH/ManageWFHFlexibilityTracker", payload);
  }

  approveWFHFlexibilityRequest(payload) {
    return withAxios.postWithToken(
      "/WFH/ApproveWFHFlexibilityRequest",
      payload
    );
  }

  CancelWFHFlexibilityRequest(payload) {
    return withAxios.postWithToken("/WFH/CancelWFHFlexibilityRequest", payload);
  }

  getApproverFlexibility(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetApproverFlexibility",
      payload
    );
  }

  getWFHApproverList(payload) {
    return withAxios.postWithToken("/WFH/GetApproverWFHFlexibilities", payload);
  }

  manageEmployees(payload) {
    return withAxios.postWithToken("/User/ManageEmployees", payload);
  }

  getAllFlexibilityTypes(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/GetAllFlexibilityTypes",
      payload
    );
  }

  getBusinessRulesByFlexibility(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/GetBusinessRulesByFlexibility",
      payload
    );
  }

  manageBusinessRules(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/ManageBusinessRules",
      payload
    );
  }

  generateHeadCountReport(payload) {
    return withAxios.postWithToken("/Reports/GenarateHeadCountReport", payload);
  }

  generateReport(payload) {
    return withAxios.postWithToken("/Reports/ReportGenaration", payload);
  }

  getBusinessRulesForAllFlexibility(payload) {
    return withAxios.postWithToken(
      "/Reports/GetBusinessRulesForAllFlexibility",
      payload
    );
  }

  wfhReportGeneration(payload) {
    return withAxios.postWithToken("/Reports/WFHReportGenaration", payload);
  }
  fileBulkUpload(payload) {
    return withAxios.postWithToken("/Reports/FileBulkUpload", payload);
  }
  getHolidays(payload) {
    return withAxios.postWithToken("/Calendar/GetHolidays", payload);
  }
  addHoliday(payload) {
    return withAxios.postWithToken("/Calendar/AddHoliday", payload);
  }
  updateHoliday(payload) {
    return withAxios.postWithToken("/Calendar/UpdateHoliday", payload);
  }

  deleteHoliday(payload) {
    return withAxios.postWithToken("/Calendar/DeleteHoliday", payload);
  }

  getPeriodCalendar(payload) {
    return withAxios.postWithToken("/Calendar/GetPeriodCalendar", payload);
  }
  updateSeason(payload) {
    return withAxios.postWithToken("/Calendar/UpdateSeason", payload);
  }

  addSeasons(payload) {
    return withAxios.postWithToken("/Calendar/AddSeasons", payload);
  }
  deleteSeason(payload) {
    return withAxios.postWithToken("/Calendar/DeleteSeason", payload);
  }

  getAllEmailTemplates(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/GetAllEmailTemplates",
      payload
    );
  }
  getActiveBaseTemplateItems(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/GetActiveBaseTemplateItems",
      payload
    );
  }

  getActiveEmailTemplateBasedOnBaseTemplate(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/GetActiveEmailTemplateBasedOnBaseTemplate",
      payload
    );
  }
  getEmailTemplateContent(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/GetEmailTemplateContent",
      payload
    );
  }

  addEmailTemplate(payload) {
    return withAxios.postWithToken("/EmailTemplate/AddEmailTemplate", payload);
  }

  updateEmailTemplate(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/UpdateEmailTemplate",
      payload
    );
  }

  deleteEmailTemplate(payload) {
    return withAxios.postWithToken(
      "/EmailTemplate/DeleteEmailTemplate",
      payload
    );
  }

  getAllFlexibilityTypesForIsActiveCheck(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/GetAllFlexibilityTypesForIsActiveCheck",
      payload
    );
  }

  manageFlexibilityTypes(payload) {
    return withAxios.postWithToken(
      "/BusinessRule/ManageFlexibilityTypes",
      payload
    );
  }

  addSurveyDetails(payload) {
    return withAxios.postWithToken("/Flexibility/AddSurveyDetails", payload);
  }

  autoSaveUserPreference(payload) {
    return withAxios.postWithToken("/User/ManageUserPreferences", payload);
  }

  getUserPreference(payload) {
    return withAxios.postWithToken("/User/GetUserPreferences", payload);
  }

  getDTEUserInfo(payload) {
    return withAxios.postWithToken("/DTE/GetDTEUserInfoDetails", payload);
  }

  getDTEusedHours(payload) {
    return withAxios.postWithToken("/Flexibility/GetUsedDTEHours", payload);
  }

  getAutoApprovedFlexibilityList(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetAutoApprovedFlexibilitiesList",
      payload
    );
  }

  getAutoApprovalExclusion(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetAutoApprovalExclusionDetail",
      payload
    );
  }

  insertOrUpdateAutoApprovalExclusion(payload) {
    return withAxios.postWithToken(
      "/Flexibility/InsertOrUpdateAutoApprovalExclusion",
      payload
    );
  }

  getSuperAdminViewCheckForAutoApprovalAdmin(payload) {
    return withAxios.postWithToken(
      "/Flexibility/GetSuperAdminViewCheckForAutoApprovalAdmin",
      payload
    );
  }

  revokeFlexibility(payload) {
    return withAxios.postWithToken(
      "/Flexibility/ManageFlexibilityForAutoApprovedRequest",
      payload
    );
  }

  getNotificationMessage(payload) {
    return withAxios.postWithToken(
      "/Notification/GetActiveNotificationMessage",
      payload
    );
  }
}

export default new PtoTrackerService();
